module.exports = __webpack_public_path__ + "static/media/sidebar-email.8c77b3a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-email.svg
// module id = 791
// module chunks = 0